import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  adCardHeader: {
    padding: 8,
    paddingBottom: 6
  },
  headerTop: {
    display: 'flex',
    marginBottom: 8
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around'
  },
  name: {
    fontSize: 11,
    fontStyle: 'normal',
    letterSpacing: 'normal',
    minWidth: 55
  },
  pageName: {
    fontWeight: 700
  },
  description: {
    fontSize: 9
  },
  adText: {
    padding: '0 4px',
    fontSize: 10,
    lineHeight: '12px',
    color: '#000',
    whiteSpace: 'pre-wrap'
  }
})

export default useStyles
